import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    TITLE: {
        id: 'admin.notification.title',
        defaultMessage: 'Setting e-mail'
    },
    SELECT_COUNTRY: {
        id: 'admin.notification.selectCountry',
        defaultMessage: 'Select a country'
    },
    SUBJECT: {
        id: 'admin.notification.subject',
        defaultMessage: 'Subject'
    },
    MESSAGE: {
        id: 'admin.notification.message',
        defaultMessage: 'Message'
    }
});

export default messages;
